module.exports = __webpack_public_path__ + "img/GS_Profile-Constance Matheba.1804deae.png";